import { Star, Quote } from "lucide-react";
import { GOOGLE_REVIEWS } from "@/lib/reviews-data";

function getInitial(name) {
  return name.trim().charAt(0).toUpperCase();
}

const STAR_KEYS = ["s1", "s2", "s3", "s4", "s5"];

function StarRow({ count }) {
  return (
    <div className="flex items-center gap-0.5">
      {STAR_KEYS.slice(0, count).map((key) => (
        <Star
          key={key}
          className="w-4 h-4 fill-[var(--accent)] text-[var(--accent)]"
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}

function ReviewCard({ review, lang }) {
  return (
    <div
      className="card-surface p-7 sm:p-8 max-w-md mx-auto"
      data-testid={`review-item-${review.id}`}
    >
      <div className="flex items-start gap-4 mb-5">
        <div className="w-12 h-12 rounded-full bg-[var(--primary)] text-white font-heading text-xl flex items-center justify-center flex-shrink-0">
          {getInitial(review.name)}
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-bold text-[var(--heading)]">{review.name}</div>
          <div className="flex items-center gap-2 mt-1">
            <StarRow count={review.rating} />
            <span className="text-xs text-[var(--muted)]">
              {review.date[lang] || review.date.hu}
            </span>
          </div>
        </div>
        <Quote
          className="w-6 h-6 text-[var(--secondary)]/40 flex-shrink-0"
          strokeWidth={1.5}
        />
      </div>
      <p className="text-[var(--body)] text-lg leading-relaxed">
        &ldquo;{review.text}&rdquo;
      </p>
    </div>
  );
}

function getGridClass(count) {
  if (count === 1) return "flex justify-center";
  if (count === 2) return "grid grid-cols-1 md:grid-cols-2 gap-6";
  return "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6";
}

export default function ReviewsStrip({ t, lang }) {
  if (GOOGLE_REVIEWS.length === 0) return null;

  return (
    <section
      id="testimonials"
      className="pt-20 sm:pt-28 pb-8 bg-white"
      data-testid="reviews-strip"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10">
        <div className="text-center mb-12 reveal">
          <div className="flex items-center justify-center gap-2 mb-3">
            <StarRow count={5} />
            <span className="font-bold text-[var(--heading)]">5.0</span>
            <span className="text-[var(--muted)] text-sm">· Google</span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl">
            {t.testimonials.title}
          </h2>
        </div>

        <div className={`${getGridClass(GOOGLE_REVIEWS.length)} reveal`}>
          {GOOGLE_REVIEWS.map((r) => (
            <ReviewCard key={r.id} review={r} lang={lang} />
          ))}
        </div>
      </div>
    </section>
  );
}
